import { Pipe, PipeTransform } from '@angular/core';

// Removes the random string added to files in our upload process
@Pipe({ name: 'fileName' })
export class FileNamePipe implements PipeTransform {
  transform(fileName: string) {
    if (!fileName.includes('.') || !fileName.includes('-')) {
      return fileName;
    }

    const fileExt = fileName.split('.').pop();
    const fileNameStart = fileName.substring(0, fileName.lastIndexOf('-'));

    return `${fileNameStart}.${fileExt}`;
  }
}
